import { render, staticRenderFns } from "./OpenEntityInNewWindowBtn.vue?vue&type=template&id=1fda712d&"
import script from "./OpenEntityInNewWindowBtn.vue?vue&type=script&lang=ts&"
export * from "./OpenEntityInNewWindowBtn.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
